import React from 'react';
import Footer from '../Components/Outlets/Footer';
import Nav from '../Components/Outlets/Nav';
import AdmissionForm from './AdmissionForm';
import 'bootstrap/dist/css/bootstrap.min.css'; // If using Bootstrap

const Admission = () => {
  return (
    <div className='admission-container'>
      <Nav />
      <div className="path-menu">
        <div className="container">
          <h2 className="page-heading-name mb-4">Admissions.</h2>
        </div>
      </div>
      <div className="container">
        <h3 className='admission-opn-txt mb-4'>Application for Admission</h3>
        <AdmissionForm />
      </div>
      <Footer />
    </div>
  );
};

export default Admission;